import { connect } from 'react-redux';

import { showAboutModal } from '../../../modules/AboutModal';
import { showGuidedTour } from '../../../modules/GuidedTour';
import { Header, HeaderProps } from './Header';

const mapDispatch: HeaderProps = {
	onClickAbout: showAboutModal,
	onClickGuidedTour: showGuidedTour,
};

export const ConnectedHeader = connect(null, mapDispatch)(Header);
